/* @flow strict */

import moment from 'moment';
import { currency } from '/client/src/constants/';

export const columns = [
  {
    selector: 'date',
    name: 'Date(UTC)',
    sortable: true,
    cell: (row: {}) => {
      try {
        const date = moment(
          row.payout_transaction_event_created_time_utc
        ).format('MM/DD/YYYY');

        return date;
      } catch (e) {
        console.log(e);

        return '';
      }
    }
  },
  {
    selector: 'currency',
    name: 'Currency',
    sortable: true
  },
  {
    selector: 'amount',
    name: 'Another Transfered',
    sortable: true,
    cell: (row: {}) => {
      return `${currency[row.currency]}${row.amount / 100}`;
    }
  },
  {
    selector: 'fee',
    name: 'Fee',
    sortable: true,
    cell: (row: {}) => {
      return `${currency[row.currency]}${row.fee / 100}`;
    }
  },
  {
    selector: 'net',
    name: 'Net',
    sortable: true,
    cell: (row: {}) => {
      return `${currency[row.currency]}${row.net / 100}`;
    }
  },
  {
    selector: 'type',
    name: 'Type',
    sortable: true
  },
  {
    selector: 'description',
    name: 'Description',
    sortable: true
  }
];
